var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTooltipWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.42925 5.86408C9.18486 6.1068 9.06266 6.4021 9.06266 6.75C9.06266 7.0979 9.18486 7.3932 9.42925 7.63592C9.67364 7.87864 9.96811 8 10.3127 8C10.6572 8 10.9517 7.87864 11.1961 7.63592C11.4405 7.3932 11.5627 7.0979 11.5627 6.75C11.5627 6.4021 11.4405 6.1068 11.1961 5.86408C10.9517 5.62136 10.6572 5.5 10.3127 5.5C9.96811 5.5 9.67364 5.62136 9.42925 5.86408Z",
    fill: "#1D41FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 13.7375H13.125V14.9875H7.5V13.7375H9.375V9.98753H7.53768V8.73753H11.25V13.7375Z",
    fill: "#1D41FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipWhite);
export default __webpack_public_path__ + "static/media/tooltip-white.3363673c1d64003f8f257fe3015ecedc.svg";
export { ForwardRef as ReactComponent };